import { useNavigation } from '@refinedev/core'

export function useTableRowNavigation(resource: string) {
  const { show } = useNavigation()

  return (record: { id: string }) => ({
    onClick: (e: React.MouseEvent) => {
      const target = e.target as HTMLElement
      if (
        target.closest('.ant-btn') ||
        target.closest('.ant-checkbox-wrapper') ||
        target.closest('.ant-typography-copy') ||
        target.closest('.ant-dropdown') ||
        target.closest('[role="menu"]')
      )
        return
      show(resource, record.id)
    },
    style: { cursor: 'pointer' } as const,
  })
}
